export const rcmKeys = {
  session: {
    me: ['rcm', 'session', 'me'] as const,
  },
  pmsAccess: {
    all: ['rcm', 'pms-access'] as const,
    status: (practiceId: string) => ['rcm', 'pms-access', 'status', practiceId] as const,
  },
  worklist: {
    all: ['rcm', 'worklist'] as const,
    list: (filters?: Record<string, unknown>) =>
      ['rcm', 'worklist', 'list', filters] as const,
    detail: (id: string) => ['rcm', 'worklist', 'detail', id] as const,
    counts: ['rcm', 'worklist', 'counts'] as const,
    families: ['rcm', 'worklist', 'families'] as const,
  },
  claims: {
    all: ['rcm', 'claims'] as const,
    list: (filters?: Record<string, unknown>) => ['rcm', 'claims', 'list', filters] as const,
    detail: (id: string) => ['rcm', 'claims', 'detail', id] as const,
    banner: ['rcm', 'claims', 'banner'] as const,
    audit: (id: string) => ['rcm', 'claims', 'audit', id] as const,
  },
  preauths: {
    all: ['rcm', 'preauths'] as const,
    list: (filters?: Record<string, unknown>) => ['rcm', 'preauths', 'list', filters] as const,
    detail: (id: string) => ['rcm', 'preauths', 'detail', id] as const,
    audit: (id: string) => ['rcm', 'preauths', 'audit', id] as const,
  },
  posting: {
    all: ['rcm', 'posting'] as const,
    list: (filters?: Record<string, unknown>) => ['rcm', 'posting', 'list', filters] as const,
    detail: (id: string) => ['rcm', 'posting', 'detail', id] as const,
    audit: (id: string) => ['rcm', 'posting', 'audit', id] as const,
  },
  ar: {
    all: ['rcm', 'ar'] as const,
    insuranceList: (filters?: Record<string, unknown>) =>
      ['rcm', 'ar', 'insurance', 'list', filters] as const,
    insuranceDetail: (id: string) => ['rcm', 'ar', 'insurance', 'detail', id] as const,
    insuranceAging: ['rcm', 'ar', 'insurance', 'aging'] as const,
    insuranceBanner: ['rcm', 'ar', 'insurance', 'banner'] as const,
    insuranceAudit: (id: string) => ['rcm', 'ar', 'insurance', 'audit', id] as const,
    patientList: (filters?: Record<string, unknown>) =>
      ['rcm', 'ar', 'patient', 'list', filters] as const,
    patientDetail: (id: string) => ['rcm', 'ar', 'patient', 'detail', id] as const,
    patientAging: ['rcm', 'ar', 'patient', 'aging'] as const,
    patientAudit: (id: string) => ['rcm', 'ar', 'patient', 'audit', id] as const,
  },
  documents: {
    all: ['rcm', 'documents'] as const,
    list: (filters?: Record<string, unknown>) =>
      ['rcm', 'documents', 'list', filters] as const,
    detail: (id: string) => ['rcm', 'documents', 'detail', id] as const,
    capture: (id: string) => ['rcm', 'documents', 'capture', id] as const,
  },
} as const;
